import Strings from "../core/data/Strings";
import ResizableContainer from "../core/ResizableContainer";
import ResizableScene from "../core/ResizableScene";
import ScaleManager from "../core/ScaleManager";
import GameColors from "../GameColors";
import PlayerData from "../PlayerData";
import { GameScene } from "../scenes/GameScene";
import Fonts from "../utils/Fonts";
import { PauseScreen } from "./PauseScreen";

export default class ConfirmQuitPopup extends ResizableContainer {
	private _onResize: () => void;
	private _parent: PauseScreen;
	private _overlay: Phaser.GameObjects.Image;
	private _popupGroup: Phaser.GameObjects.Container;
	private _onYes: () => void;
	private _onNo: () => void;
	static isOpen: boolean;
	scene: GameScene;
	constructor(scene: GameScene, parent: PauseScreen, onYes?: () => void, onNo?: () => void) {
		super(scene, 0, 0);
		this.scene = scene;
		this._parent = parent;
		ConfirmQuitPopup.isOpen = true;
		this._onYes = onYes;
		this._onNo = onNo;
		this._overlay = scene.add.image(0, 0, "missionsBG");
		this.add(this._overlay);
		this._overlay.alpha = 0.01;
		this._overlay.setInteractive();

		const popupContainer = (this._popupGroup = scene.add.container(0, 0));
		this.add(popupContainer);

		const bg = scene.add.image(0, 0, "pauseBacker");
		popupContainer.add(bg);
		popupContainer.setSize(bg.width, bg.height);

		const logo = scene.add.image(0, 0, "splashLogo");
        logo.scale = 0.575;
		popupContainer.add(logo);

		const textBacker = scene.add.image(0, 0, "pauseBtnBacker");
		popupContainer.add(textBacker);

		const bodyText = scene.add.text(0, 0, Strings.get("ConfirmQuitMessage"), {
			color: "#583306",
			fontSize: "45px",
			fontFamily: Fonts.MaliBoldItalic,
			align: "center",
			wordWrap: {width: 800},
		});
		popupContainer.add(bodyText);

		const noButton = scene.add.button(0, 0, "exitBtn", 0, this.close, this, true);
		popupContainer.add(noButton);

		const yesButton = scene.add.button(0, 0, "cqCheckBtn", 0, this.returnHome, this, true);
		popupContainer.add(yesButton);

		this._onResize = (): void => {
			ScaleManager.ScaleBackgroundFromZone(this._overlay, scene.viewport);
			scene.alignIn.Center(this._overlay, scene.viewport, 0, 0);
			// scene.alignIn.Center(starBurst, bg);
			scene.alignIn.Center(popupContainer, scene.viewport);
			scene.alignIn.Center(textBacker, bg, 0, -5);
			scene.alignIn.Center(bodyText, textBacker, 0, 0);
			scene.alignIn.TopCenter(logo, bg, 0, 280);
			scene.alignIn.BottomCenter(noButton, bg, -150, 60);

			scene.alignIn.BottomCenter(yesButton, bg, 150, 60);
		};
		this.resize();
		this.build();
	}

	returnHome(): void {
		PlayerData.resetMissionProgress(this.scene.previousMissionProgress);
        if(this._onYes) {
			this._onYes.call(this._onYes);
		}
	}

	build(): void {
		this.scene.add.tween({
			targets: this._popupGroup,
			y: { from: this._popupGroup.y + this.scene.viewport.height, to: this._popupGroup.y },
			duration: 400,
			delay: 200,
			ease: Phaser.Math.Easing.Back.Out,
		});
		this._popupGroup.y += this.scene.viewport.height;
	}

	close(): void {
		if(this._onNo) this._onNo.call(this._onNo);

		this.scene.add.tween({
			targets: this._popupGroup,
			y: { from: this._popupGroup.y, to: this._popupGroup.y + this.scene.viewport.height },
			duration: 400,
			ease: Phaser.Math.Easing.Back.In,
			onComplete: () => {
				ConfirmQuitPopup.isOpen = false;
				this.destroy();
			},
		});

		this.scene.add.tween({
			targets: this._parent.popup,
			y: { from: this._parent.popup.y, to: this._parent.popup.y - this.scene.viewport.height },
			duration: 400,
			delay: 200,
			ease: Phaser.Math.Easing.Back.Out,
		});
	}

	resize(): void {
		// super.resize();
		if (this._onResize) this._onResize();
	}
}
